import {
  ADD_HOLIDAY,
  DELETE_HOLIDAY,
  GET_HOLIDAYS,
  HOLIDAY_ERROR,
  UPDATE_HOLIDAY,
} from 'src/actions/types'

const initialState = {
  holidays: {
    data: [],
    current_page: 1,
  },
  filters: {},
  loading: true,
  error: {},
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case GET_HOLIDAYS:
      return {
        ...state,
        holidays: payload,
        filters: payload.filters,
        loading: false,
      }
    case ADD_HOLIDAY:
      return {
        ...state,
        holidays: { data: [payload, ...state.holidays.data] },
        loading: false,
      }
    case UPDATE_HOLIDAY: {
      let index = state.holidays.data.findIndex((holiday) => holiday.id === payload.id)
      state.holidays.data[index] = { ...state.holidays.data[index], ...payload }
      return {
        ...state,
        holidays: { data: [...state.holidays.data], ...state.holidays },
        loading: false,
      }
    }
    case DELETE_HOLIDAY:
      return {
        ...state,
        holidays: { data: state.holidays.data.filter((holiday) => holiday.id !== payload) },
        loading: false,
      }
    case HOLIDAY_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      }
    default:
      return state
  }
}
